import * as watchers from './grid-watchers'
import { fork } from 'redux-saga/effects'

export default [
  fork(watchers.watchGridLoadEventGroup),
  fork(watchers.watchGridSave),
  fork(watchers.watchGridCancel),
]



/** WEBPACK FOOTER **
 ** ./src/sagas/grid/index.js
 **/